var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('inform'),_c('router-link',{attrs:{"to":"/task"}},[_vm._v("Go Back to Study")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }